import { render, staticRenderFns } from "./InputMultiSelect.vue?vue&type=template&id=5652374a&scoped=true"
import script from "./InputMultiSelect.vue?vue&type=script&lang=js"
export * from "./InputMultiSelect.vue?vue&type=script&lang=js"
import style0 from "./InputMultiSelect.vue?vue&type=style&index=0&id=5652374a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5652374a",
  null
  
)

export default component.exports